import React from 'react';
import { DocumentProvider } from '../context/DocumentContext';
import { TableProvider } from '../components/shared/table/context/TableContext';
import DocumentsContent from './DocumentsContent';

const Documents = () => {
  return (
    <DocumentProvider>
      <TableProvider
        type="document_list"
        initialState={{
          loading: false,
          preferences: {
            density: 'standard',
            columnWidths: {
              title: 250,
              type_name: 120,
              size: 100,
              created_at: 120,
              notes: 200
            }
          }
        }}
      >
        <DocumentsContent />
      </TableProvider>
    </DocumentProvider>
  );
};

export default Documents;
